import {useQuery} from '@tanstack/react-query';
import {useRequiredTenantId} from '@/matic/hooks/useRequiredTenantId';
import {getMasterDataApi} from '../api/master-data-api';
import {masterDataKeys} from '../query-keys';
import type {ObjectRecord} from '../types/master-data-types';

export function useObjectRecord(typeId: string, recordId?: string) {
  const tenantId = useRequiredTenantId();
  const api = getMasterDataApi();

  return useQuery<ObjectRecord>({
    queryKey: masterDataKeys.objectRecord(typeId, recordId ?? '', tenantId),
    queryFn: async () => api.getObjectRecord(typeId, recordId!),
    enabled: Boolean(typeId) && Boolean(recordId),
  });
}
